import {
    EDIT_SWAP_SIM_CARD_OPEN_MODAL,
    EDIT_SWAP_SIM_CARD_CLOSE_MODAL,
    EDIT_SWAP_SIM_CARD_GET_DEVICE_REQUEST,
    EDIT_SWAP_SIM_CARD_GET_DEVICE_RESULT,
    EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_REQUEST,
    EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_RESULT,
    EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_REQUEST,
    EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_RESULT,
} from 'Redux/actionTypes';

export const editSwapSimCardOpenModal = (data) => ({
    type: EDIT_SWAP_SIM_CARD_OPEN_MODAL,
    payload: data
})

export const editSwapSimCardCloseModal = () => ({
    type: EDIT_SWAP_SIM_CARD_CLOSE_MODAL
})

export const editSwapSimCardGetDeviceRequest = (data) => ({
    type: EDIT_SWAP_SIM_CARD_GET_DEVICE_REQUEST,
    payload: data
})

export const editSwapSimCardGetDeviceResult = (result) => ({
    type: EDIT_SWAP_SIM_CARD_GET_DEVICE_RESULT,
    payload: result
})

export const editSwapSimCardGetSimDetailsRequest = (data) => ({
    type: EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_REQUEST,
    payload: data
})

export const editSwapSimCardGetSimDetailsResult = (result) => ({
    type: EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_RESULT,
    payload: result
})

export const editSwapSimCardUpdateRequest = (data) => ({
    type: EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_REQUEST,
    payload: data
})

export const editSwapSimCardUpdateResult = (result) => ({
    type: EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_RESULT,
    payload: result
})